module.exports = __webpack_public_path__ + "static/media/travel.13adae74.jpg";